<template>
 <v-dialog
            v-model="dialog"
            width="800"
            persistent
        >
            <v-form ref="form">
                <v-card :loading="loading">
                    <v-card-title>
                        <span class="headline">{{ 'Motivo do abono' | translate('Situacaoes')}} </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col>
                                    <v-textarea
                                        outlined
                                        :label="'Justificativa' | translate('Situacaoes')"
                                        v-model="reason"
                                    >
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="closeModal()"
                        >
                            {{'Cancelar' | translate('Atendimento')}}
                        </v-btn>
                        <v-btn 
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="input()"
                        >
                            {{'Salvar' | translate('Atendimento')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
</template>
<script>


export default {
    name : 'JustifyClassificationDialog',
    data() {
        return {
            loading : false,
            reason : '',
            dialog : true
        }
    },
    methods : {
        input(){
            this.$emit('input', this.reason)
        },
        closeModal(){
            this.$emit('close')
        }
    }
}
</script>
